import React from 'react'

import { LogoProps } from '../interfaces'

export const CompanyInitialLetter = ({ className }: LogoProps) => {
  return (
    <svg
      className={className}
      width={32}
      height={23}
      viewBox="0 0 32 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.0853 0.00597044H26.8645C20.3363 0.00597044 17.1631 9.77303 17.1631 9.77303V2.27853H0V22.8773H6.85931V9.14381H10.5186V22.8773H17.8789C17.8789 22.8773 21.6605 6.57603 25.2005 7.7958C27.5864 8.69049 20.8583 22.8624 20.8583 22.8624H30.5776C30.5776 22.8624 31.9255 13.6321 31.9464 10.4381C32.2446 5.01326 31.3888 0 27.0793 0"
        fill="currentColor"
      />
    </svg>
  )
}
